import React from 'react';
import { Box } from '@mui/system';
import { Button, Grid, InputAdornment, TextField, Typography } from '@mui/material';
import CurrencyRupee from '@mui/icons-material/CurrencyRupee';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import { updateLibraryBookingAmountDue } from 'services/bookings';

const AmountDialog = ({onAmountUpdate, bookingDetails}) => {
  const defaultFormFields={
    amount: bookingDetails?.bookingTransaction?.amountDue || ''
  };

  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, formState: { errors } } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });


  const onSubmit = (data) => {
    const postData = {
      amount: Number(data.amount).toFixed(2),
      bookingId: bookingDetails?.bookingId,
    };
    updateLibraryBookingAmountDue({...postData}).then(({response, error}) => {
      if(error){
        onAmountUpdate(false);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      } else {
        onAmountUpdate(true);
        enqueueSnackbar("Payment updated", {variant: 'success'});
      }
    });

  }
  return (
    <Box  
      component="form"
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid container rowSpacing={3} >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography gutterBottom variant="subtitle2" component="div" noWrap >
           A total od Rs.<span style={{color: '#d32f2f', fontWeight: 600, fontSize: '1rem'}}>{bookingDetails?.bookingTransaction?.amountDue}</span> is due for this booking.<br/>
           How much are you collecting now? 
          </Typography>
          <Controller
            control={control}
            name="amount"
            id="amount"
            rules={{ required: "Enter amount" }}
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Amount"
                type="number"
                required
                error={!!errors?.amount}
                size="small"
                fullWidth
                InputProps={{
                  startAdornment: <InputAdornment position="start"><CurrencyRupee sx={{fontSize: '1.2rem'}}/></InputAdornment>,
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display: 'flex'}} justifyContent="center">
          <Button variant="contained" type="submit">Proceed</Button>
        </Grid>
      </Grid>
    </Box>
  );
}
 
export default AmountDialog;
